import React, { useEffect, useState } from 'react'
import {
  Btn,
  CustomModal,
  HeaderText,
  InputNumeroDecimal,
  InputNumeroInteiro,
  OcorrenciasDropdown,
} from '../../../../../components'
import { InputText } from 'primereact/inputtext'

import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { DataTable } from 'primereact/datatable'
import * as RetornoHttp from '../../../../../services/api/https/deliveries/retorno.http'
import {
  buildFaltaQuantityInputState,
  getFaltaInputLabels,
  getFaltaQuantityConfig,
  getFaltaQuantityValueFromInputs,
} from './falta-volume-and-units.helper'

function formatProductStep(item) {
  return {
    ...item,
    missing_reason: null,
    ...buildFaltaQuantityInputState(item, ''),
  }
}

function ModalNovaFalta({
  onSuccess,
  onModalClose,
  onError,
  delivery_id,
  delivery_step_id,
  nomeFantasia,
  identifier,
  modalContentClassName = '',
  modalStyle = null,
}) {
  // Vars

  // Hooks
  const [state, setState] = useState({
    productStep: [],
    missing_reasons: [],
    globalFilter: '',
  })

  useEffect(() => {
    getProductSteps()
  }, [delivery_id])

  // Events
  function onGlobalFilterChange(value) {
    setState(prevState => ({ ...prevState, globalFilter: value }))
  }

  const onBtnSalvarClicked = async () => {
    try {
      const info = []
      for (let i = 0; i < state.productStep.length; i++) {
        const p = state.productStep[i]
        const hasReason = Boolean(p.missing_reason)
        const hasQuantity = p.qte_missing !== '' && Number(p.qte_missing) > 0

        if (!hasReason && hasQuantity) {
          throw new Error('Selecione um motivo para a ocorrência')
        }

        if (hasReason && !hasQuantity) {
          throw new Error('Selecione a qte apurado para a ocorrência')
        }

        if (hasQuantity && hasReason) {
          info.push({
            delivery_item_id: p.delivery_item_id,
            missing_reason_id: p.missing_reason.id,
            stage: 'Entrega',
            qte_missing: Number(p.qte_missing),
          })
        }
      }

      await RetornoHttp.postMissingProductStageEntrega(delivery_step_id, info)

      onSuccess()
    } catch (e) {
      onError(e)
    }
  }

  const getProductSteps = async () => {
    try {
      const { products, missing_reasons } =
        await RetornoHttp.getInfoMissingProductStageEntrega(delivery_id)

      const missing_reasons_formatted = missing_reasons.map(m => ({
        id: m.value,
        value: m.label,
      }))
      missing_reasons_formatted.unshift({ id: 0, value: '' })
      setState(prev => ({
        ...prev,
        productStep: products.map(formatProductStep),
        missing_reasons: missing_reasons_formatted,
      }))
    } catch (e) {
      onError(e)
    }
  }

  const onFormContentChange = (item, name, value) => {
    setState(prev => ({
      ...prev,
      productStep: prev.productStep.map(product => {
        if (product.delivery_item_id !== item.delivery_item_id) {
          return product
        }

        if (name === 'missing_reason') {
          return { ...product, missing_reason: value }
        }

        if (name === 'qte_missing_volume' || name === 'qte_missing_units') {
          const nextProduct = {
            ...product,
            [name]: value,
          }

          return {
            ...nextProduct,
            qte_missing: getFaltaQuantityValueFromInputs(
              nextProduct,
              nextProduct.qte_missing_volume,
              nextProduct.qte_missing_units,
            ),
          }
        }

        return product
      }),
    }))
  }

  const renderQuantityInput = (item, field) => {
    const { canUseFractionedInput } = getFaltaQuantityConfig(item)
    const { volumeLabel, unitsLabel } = getFaltaInputLabels(item)
    const isVolumeField = field === 'qte_missing_volume'
    const label = isVolumeField ? volumeLabel : unitsLabel
    const isCustomLabel = label !== (isVolumeField ? 'Vol.' : 'Frac.')

    return (
      <div style={{ minWidth: 80 }}>
        {isCustomLabel ? (
          <div
            style={{
              fontSize: '0.72rem',
              color: '#666',
              fontWeight: 600,
              textAlign: 'center',
              marginBottom: 4,
            }}
          >
            {label}
          </div>
        ) : null}
        {isVolumeField ? (
          canUseFractionedInput ? (
            <InputNumeroInteiro
              marginTop={0}
              value={item.qte_missing_volume}
              onChange={value => onFormContentChange(item, field, value)}
              width={80}
            />
          ) : (
            <InputNumeroDecimal
              marginTop={0}
              showLabel={false}
              value={item.qte_missing_volume}
              onChange={value => onFormContentChange(item, field, value)}
              width={80}
            />
          )
        ) : (
          <InputNumeroInteiro
            marginTop={0}
            value={item.qte_missing_units}
            onChange={value => onFormContentChange(item, field, value)}
            width={80}
            disabled={!canUseFractionedInput}
          />
        )}
      </div>
    )
  }

  const header = (
    <div style={{ textAlign: 'left' }}>
      <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
      <InputText
        value={state.globalFilter}
        onChange={e => onGlobalFilterChange(e.target.value)}
        placeholder="Pesquisar . . ."
        size="50"
      />
    </div>
  )
  // Render
  return (
    <CustomModal
      header="Nova Ocorrência Falta"
      isVisible={true}
      onClose={onModalClose}
      width={'90%'}
      style={modalStyle || { backgroundColor: 'white' }}
      contentStyle={modalStyle ? null : { maxHeight: '80vh', overflowY: 'auto' }}
    >
      <div className={modalContentClassName}>
        <HeaderText>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <p style={{ padding: 0, margin: 0 }}>
              <strong>Identificador:</strong> {identifier}
            </p>
            <p style={{ padding: 0, margin: 0 }}>
              <strong>Cliente:</strong> {nomeFantasia}
            </p>
          </div>
        </HeaderText>
        <div className="p-grid">
          <div className="p-col-12">
            <Btn onClick={() => onBtnSalvarClicked()}>Salvar</Btn>
          </div>
        </div>
        <DataTable
          value={state.productStep}
          paginator={true}
          rows={10}
          header={header}
          globalFilter={state.globalFilter}
          responsive={true}
        >
          <Column field="product_code" header="Código" style={tableCellCentered()} />
          <Column field="product_name" header="Produto" />
          <Column
            header="Motivo"
            style={tableCellCentered(320)}
            body={item => {
              return (
                <OcorrenciasDropdown
                  style={{ width: '100%' }}
                  optionLabel="value"
                  value={item.missing_reason}
                  options={state.missing_reasons}
                  appendTo={document.body}
                  onChange={({ value }) => onFormContentChange(item, 'missing_reason', value)}
                  placeholder="Selecione o Motivo da Ocorrência"
                />
              )
            }}
          />
          <Column
            header="Vol."
            style={tableCellCentered(110)}
            body={item => renderQuantityInput(item, 'qte_missing_volume')}
          />
          <Column
            header="Frac."
            style={tableCellCentered(100)}
            body={item => renderQuantityInput(item, 'qte_missing_units')}
          />
        </DataTable>
      </div>
    </CustomModal>
  )
}

export default ModalNovaFalta
